<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="mainContentFullWith">
  <div class="placeHolder">
    <ejs-grid [dataSource]="dataSource"
              [columns]="columns"
              [allowPaging]="allowPaging"
              [editSettings]="editSettings"
              [pageSettings]="pageSettings"
              [toolbar]="toolbar"
              (actionBegin)="actionBegin($event)" class="unselectable">
    </ejs-grid>
    <ng-template #matDialog class="dialog">
      <h2 matDialogTitle>{{user.FirstName}} {{user.LastName}}</h2>
      <form>
        <div class="formRow">
          <mat-form-field class="formField">
            <mat-label>{{translation.FirstName}}</mat-label>
            <input name="firstName" matInput type="text" maxlength="50" [(ngModel)]="user.FirstName" [readonly]="readonly" required>
          </mat-form-field>
          <mat-form-field class="formField">
            <mat-label>{{translation.LastName}}</mat-label>
            <input name="lastName" matInput type="text" maxlength="50" [(ngModel)]="user.LastName" [readonly]="readonly" required>
          </mat-form-field>
        </div>
        <div class="formRow">
          <mat-form-field class="formField">
            <mat-label>{{translation.LoginName}}</mat-label>
            <input name="loginName" matInput type="text" maxlength="50" [(ngModel)]="user.LoginName" [readonly]="readonly" required>
          </mat-form-field>
          <mat-form-field class="formField">
            <mat-label>{{translation.Email}}</mat-label>
            <input name="email" matInput type="text" maxlength="50" [(ngModel)]="user.Email" [readonly]="readonly" required>
          </mat-form-field>
        </div>
        <div class="formRow">
          <mat-form-field class="formField">
            <mat-label>{{translation.Phone}}</mat-label>
            <input name="phone" matInput type="number" maxlength="50" id="phoneNumberInput" [(ngModel)]="user.Phone" [readonly]="readonly" required>
          </mat-form-field>
          <mat-form-field class="formField">
            <mat-select name="language" [(ngModel)]="user.Language" placeholder="{{translation.Language}}" required [disabled]="readonly">
              <mat-option *ngFor="let language of languages" [value]="language" [disabled]="readonly">{{language}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field class="formField" *ngIf="!hidden">
          <mat-chip-list #primaryAddressChipList [multiple]="false">
            <mat-chip *ngFor="let primaryAddress of primaryAddressArray" (removed)="removePrimaryAddress(primaryAddress)" [selectable]="selectable" [removable]="removable"><mat-icon matChipRemove *ngIf="!readonly">cancel</mat-icon> {{primaryAddress}}</mat-chip>
            <input #primaryAddressInput #primaryAddressTrigger="matAutocompleteTrigger" [placeholder]="translation.PrimaryAddress" matInput [formControl]="autoCompletePrimaryAddress" [matAutocomplete]="autoPrimaryAddress" [matChipInputFor]="primaryAddressChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" required [readonly]="readonly">
          </mat-chip-list>
          <mat-autocomplete #autoPrimaryAddress="matAutocomplete">
            <mat-option *ngFor="let address of filteredPrimaryAddresses | async" [value]="address" (onSelectionChange)="addPrimaryAddress(address.PartnerAid)" (click)="$event.stopPropagation(); primaryAddressTrigger.openPanel()" [disabled]="readonly">
              {{address.PartnerAid != '' ? address.PartnerAid + ', ' : ''}}
              {{address.Description != '' ? address.Description + ', ' : ''}}
              {{address.DeliveryAddition != '' ? address.DeliveryAddition + ', ' : ''}}
              {{address.DeliveryStreet != '' ? address.DeliveryStreet + ', ' : ''}}
              {{address.DeliveryZip != '' ? address.DeliveryZip + ', ' : ''}}
              {{address.DeliveryCity != '' ? address.DeliveryCity : ''}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field class="formField" *ngIf="!hidden">
          <mat-chip-list #homeDeliveryPartnerAddressChipList [multiple]="false">
            <mat-chip *ngFor="let homeDeliveryPartnerAddress of homeDeliveryPartnerAddressArray" (removed)="removeHomeDeliveryPartnerAddress(homeDeliveryPartnerAddress)" [selectable]="selectable" [removable]="removable"><mat-icon matChipRemove *ngIf="!readonly">cancel</mat-icon> {{homeDeliveryPartnerAddress}}</mat-chip>
            <input #homeDeliveryPartnerAddressInput #homeDeliveryPartnerAddressTrigger="matAutocompleteTrigger" [placeholder]="translation.HomeDeliveryPartnerAddress" matInput [formControl]="autoCompleteHomeDeliveryPartnerAddress" [matAutocomplete]="autoHomeDeliveryPartnerAddress" [matChipInputFor]="homeDeliveryPartnerAddressChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" required [readonly]="readonly">
          </mat-chip-list>
          <mat-autocomplete #autoHomeDeliveryPartnerAddress="matAutocomplete">
            <mat-option *ngFor="let address of filteredHomeDeliveryAddresses | async" [value]="address" (onSelectionChange)="addHomeDeliveryPartnerAddress(address.PartnerAid)" (click)="$event.stopPropagation(); homeDeliveryPartnerAddressTrigger.openPanel()" [disabled]="readonly">
              {{address.PartnerAid != '' ? address.PartnerAid + ', ' : ''}}
              {{address.Description != '' ? address.Description + ', ' : ''}}
              {{address.DeliveryAddition != '' ? address.DeliveryAddition + ', ' : ''}}
              {{address.DeliveryStreet != '' ? address.DeliveryStreet + ', ' : ''}}
              {{address.DeliveryZip != '' ? address.DeliveryZip + ', ' : ''}}
              {{address.DeliveryCity != '' ? address.DeliveryCity : ''}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field class="formField" *ngIf="!hidden">
          <mat-chip-list #partnerChipList>
            <mat-chip *ngFor="let partner of partnerArray" (removed)="removePartner(partner)" [selectable]="selectable" [removable]="removable"><mat-icon matChipRemove *ngIf="!readonly">cancel</mat-icon> {{partner}}</mat-chip>
            <input #partnerInput #partnerTrigger="matAutocompleteTrigger" [placeholder]="translation.Partner" matInput [formControl]="autoCompletePartner" [matAutocomplete]="autoPartner" [matChipInputFor]="partnerChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" required [readonly]="readonly">
          </mat-chip-list>
          <mat-autocomplete #autoPartner="matAutocomplete">
            <mat-option *ngFor="let partner of filteredPartners | async" [value]="partner" (onSelectionChange)="addPartner(partner.PartnerAid)" (click)="$event.stopPropagation(); partnerTrigger.openPanel()" [disabled]="readonly">
              {{partner.PartnerAid != '' ? partner.PartnerAid + ', ' : ''}}
              {{partner.Description != '' ? partner.Description + ', ' : ''}}
              {{partner.DeliveryAddition != '' ? partner.DeliveryAddition + ', ' : ''}}
              {{partner.DeliveryStreet != '' ? partner.DeliveryStreet + ', ' : ''}}
              {{partner.DeliveryZip != '' ? partner.DeliveryZip + ', ' : ''}}
              {{partner.DeliveryCity != '' ? partner.DeliveryCity : ''}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field class="formField" *ngIf="!hidden">
          <mat-chip-list #partnerGroupChipList>
            <mat-chip *ngFor="let partnerGroup of partnerGroupArray" [selectable]="selectable" [removable]="removable" (removed)="removePartnerGroup(partnerGroup)"><mat-icon matChipRemove *ngIf="!readonly">cancel</mat-icon> {{partnerGroup}}</mat-chip>
            <input #partnerGroupInput #partnerGroupTrigger="matAutocompleteTrigger" [placeholder]="translation.Companies" matInput [formControl]="autoCompletePartnerGroup" [matAutocomplete]="autoPartnerGroup" [matChipInputFor]="partnerGroupChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" required [readonly]="readonly">
          </mat-chip-list>
          <mat-autocomplete #autoPartnerGroup="matAutocomplete">
            <mat-option *ngFor="let partnerGroup of filteredPartnerGroups | async" [value]="partnerGroup" (onSelectionChange)="addPartnerGroup(partnerGroup)" (click)="$event.stopPropagation(); partnerGroupTrigger.openPanel()" [disabled]="readonly">{{partnerGroup}}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field class="formField" *ngIf="!hidden && currentUserIsSystemAdmin">
          <mat-label>{{translation.ProcessIds}}</mat-label>
          <input name="processIds" matInput type="text" maxlength="100" [(ngModel)]="user.ProcessIds" placeholder="Mehrere ProzessIds mit ; trennen.">
        </mat-form-field>
        <mat-form-field class="formField" *ngIf="!hidden && currentUserIsSystemAdmin">
          <mat-label>{{translation.OrderSource}}</mat-label>
          <input name="orderSource" matInput type="text" maxlength="50" [(ngModel)]="user.OrderSource">
        </mat-form-field>
        <div class="checkBoxContent">
          <div class="moduleContent">
            <h4>{{translation.Modules}}</h4>
            <ul class="checkboxList">
              <li *ngFor="let module of modules">
                <mat-checkbox #moduleCheckboxItems (change)="addOrRemoveUserModule($event, module.ModuleId)" [id]="'module' + module.ModuleId" color="primary" checked="false" [disabled]="readonlyTransportModule && readonlyStatusModule && readonlyModules">{{module.ModuleName}}</mat-checkbox>
              </li>
            </ul>
          </div>
          <div class="rightContent">
            <h4>{{translation.Rights}}</h4>
            <ul class="checkboxList">
              <li *ngFor="let right of rights">
                <mat-checkbox #rightCheckboxItems (change)="addOrRemoveUserRight($event, right.RightId)" [id]="'right' + right.RightId" color="primary" checked="false" [disabled]="readonlyStatusRights && readonlyTransportRights && readonlyRights">{{right.Description}}</mat-checkbox>
              </li>
            </ul>
          </div>
          <div class="settingsContent" *ngIf="currentUserIsAdmin">
            <h4>Admin-{{translation.Settings}}</h4>
            <ul class="checkboxList">
              <li>
                <mat-checkbox [checked]="user.MultiPartnerUser" (change)="userSettingChange($event, 'multiPartnerUser')" color="primary">{{translation.MultiPartnerUser}}</mat-checkbox>
              </li>
              <li>
                <mat-checkbox [checked]="user.ConfirmationMailAsked" (change)="userSettingChange($event, 'confirmationMailAsked')" color="primary">{{translation.ConfirmationMailAsked}}</mat-checkbox>
              </li>
              <li>
                <mat-checkbox [checked]="user.SaturdayDelivery" (change)="userSettingChange($event, 'saturdayDelivery')" color="primary">{{translation.SaturdayDeliveryAllowed}}</mat-checkbox>
              </li>
              <li>
                <mat-checkbox [checked]="user.WnExternal" (change)="userSettingChange($event, 'wnExternal')" color="primary" disabled="{{!user.WnExternal}}">Wheelnews-External</mat-checkbox>
              </li>
            </ul>
          </div>
          <div class="settingsContent">
            <h4>{{translation.Settings}}</h4>
            <ul class="checkboxList">
              <li>
                <mat-checkbox [checked]="user.ConfirmationMail" (change)="userSettingChange($event, 'confirmationMail')" color="primary">{{translation.ConfirmationMail}}</mat-checkbox>
              </li>
            </ul>
          </div>
        </div>
        <div class="formRow">
          <mat-form-field class="formField readOnlyFormField unselectable">
            <mat-label>{{translation.LastUpdate}}</mat-label>
            <input name="lastUpdate" matInput class="unselectable" type="text" [(ngModel)]="lastUpdate" [readonly]="true">
          </mat-form-field>
          <mat-form-field class="formField threeLines readOnlyFormField unselectable">
            <mat-label>{{translation.CreationDate}}</mat-label>
            <input name="creationDate" matInput class="unselectable" type="text" [(ngModel)]="creationDate" [readonly]="true">
          </mat-form-field>
          <mat-form-field class="formField readOnlyFormField unselectable">
            <mat-label>{{translation.CreatedBy}}</mat-label>
            <input name="createdBy" matInput class="unselectable" type="text" [(ngModel)]="creatorName" [readonly]="true">
          </mat-form-field>
        </div>
      </form>
      <mat-dialog-actions class="justify-content-between">
        <button mat-button class="customButtons" (click)="cancel()">{{translation.Cancel}}</button>
        <button mat-button class="customButtons" (click)="resetPassword()">{{translation.ResetPassword}}</button>
        <button mat-button class="customButtons" (click)="save()" [disabled]="readonly">{{translation.Save}}</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
</div>
<app-footer></app-footer>
